<template>
  <ProSpacePanelBlock class="selected-items" v-if="selectedClude?.items?.length > 0" :header="headerClude">
    <template #header>
      <ProSpaceAction :text="$t('clearTxt')" @click="clickHandlerClear" />
    </template>
    <ProSpaceSimpleGrid
      :headers="items"
      :items="selectedClude.items"
      :btnText="$t('viewMore')"
      :defaultModal="false"
      @open-modal="modelModal = true"
    />
    <ProSpaceModal
      v-model="modelModal"
      icon="parameters"
      :title="
        $t(
          `${selectedClude.isAll ? 'listExcluded' : 'listIncluded'}`
        )
      "
      :contentStyle="{
        width: '50vw',
        height: '418px',
      }"
      applyTxt=""
      :cancelTxt="$t('closeTxt')"
    >
      <ProSpaceSimpleGrid
        :headers="items"
        :items="selectedClude.items"
        :btnText="$t('viewMore')"
        :limit="null"
      />
    </ProSpaceModal>
  </ProSpacePanelBlock>
</template>

<script>
import {
  useMultiSelectRightPanel,
} from "@composes/multiselect"
import {
  ProSpacePanelBlock,
  ProSpaceAction,
  ProSpaceSimpleGrid,
  ProSpaceModal
} from "@prospace/prospace-components-library";
export default {
  components: {
    ProSpacePanelBlock,
    ProSpaceAction,
    ProSpaceSimpleGrid,
    ProSpaceModal
  },
  name: "PanelBlockSelectedItems",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      modelModal: false
    }
  },
  setup() {
    const { selectedClude, selectedActionClear } = useMultiSelectRightPanel()
    return {
      selectedClude, selectedActionClear
    }
  },
  computed: {
    headerClude() {
      return {
        title: this.$t(`${this.selectedClude.isAll ? "itemsExcluded" : "itemsIncluded"}`),
        counter: this.selectedClude.items.length,
        showCounter: true,
      };
    },
  },
  methods: {
    clickHandlerClear() {
      this.selectedActionClear();
      this.$emit('clear')
    }
  }
};
</script>

<style lang="scss" scoped>
  .selected-items {
    :deep(.prospace-list-items-table .p-datatable-tbody > tr > td:first-child) {
      padding-left: 0;
    }
  }
</style>
